// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J3uE","field":"styles_field__28QcB","fieldCol":"styles_fieldCol__-s9C9","diffCol":"styles_diffCol__37JyJ","diff":"styles_diff__y7bQc"};